<template>
    <div class="card mb-4">
        <div class="card-header">
            <div class="pull-right mobile-hide">
                <img :src="window.env.baseAssetUri + 'images/icon-cc-flag-vi.png'" width="26" alt="Visa">
                <img :src="window.env.baseAssetUri + 'images/icon-cc-flag-ca.png'" width="26" alt="Master Card">
            </div>
            <h2 class="card-title">{{ $t('cars.checkout.payment.panelTitle')}}</h2>
        </div>
        <div class="card-body">
            <div class="form-group">
                <strong>{{ $t('cars.checkout.payment.cc.heading')}}</strong>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="cc_type_select" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.type')}}
                        </label>
                        <select id="cc_type_select"
                                class="form-control custom-select"
                                v-model="billing.card.type"
                                v-validate="'card.type'">
                            <option value="VI">Visa</option>
                            <option value="CA">Mastercard</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="cc_first_name" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.firstName')}}
                        </label>
                        <input type="text"
                               id="cc_first_name"
                               required
                               maxlength="50"
                               class="form-control"
                               v-model="billing.card.firstName"
                               v-validate="'card.firstName'">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="cc_last_name" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.lastName')}}
                        </label>
                        <input type="text"
                               id="cc_last_name"
                               required
                               maxlength="50"
                               class="form-control"
                               v-model="billing.card.lastName"
                               v-validate="'card.lastName'">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="cc_number" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.number')}}
                        </label>
                        <input type="text"
                               id="cc_number"
                               required
                               class="form-control"
                               v-model="billing.card.number"
                               v-validate="'card.number'"
                               placeholder="XXXX XXXX XXXX XXXX">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group required">
                        <label for="cc_expiry_month" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.expiry')}}
                        </label>
                        <div class="form-row">
                            <div class="col-md">
                                <select id="cc_expiry_month"
                                        :aria-label=" $t('cars.checkout.payment.cc.expiryMonth')"
                                        class="form-control custom-select"
                                        v-model="billing.card.expiryMonth"
                                        v-validate="'card.expiryMonth'">
                                    <option v-for="month in range(1, 12)" :value="month">
                                        {{ window.padNumber(month, 2) }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md">
                                <select id="cc_expiry_year"
                                        :aria-label="$t('cars.checkout.payment.cc.expiryYear')"
                                        class="form-control custom-select"
                                        v-model="billing.card.expiryYear"
                                        v-validate="'card.expiryYear'">
                                    <option v-for="year in range(minYear, maxYear)"
                                            :value="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group required">
                        <label for="cc_cvv" class="form-control-label">
                            {{ $t('cars.checkout.payment.cc.cvv')}}
                        </label>
                        <a @click.prevent="openCvvPopup">
                            <i class="fa fa-info-circle"></i>
                        </a>
                        <input type="number"
                               id="cc_cvv"
                               min="0"
                               max="9999"
                               required
                               placeholder="XXX"
                               class="form-control"
                               v-model="billing.card.cvv"
                               v-validate="'card.cvv'">
                    </div>
                </div>
            </div>
            <hr>
            <div class="form-group">
                <strong>{{ $t('cars.checkout.payment.billing.heading')}}</strong>
            </div>
            <div v-if="billing.canUseDriverAddress" class="form-group">
                <div class="form-check">
                    <input type="checkbox"
                           class="form-check-input"
                           id="billing_useDriverAddress"
                           v-model="billing.useDriverAddress"
                           :true-value="1"
                           :false-value="0"
                    >
                    <label class="form-check-label" for="billing_useDriverAddress">
                        {{ $t('cars.checkout.payment.billing.useSame')}}
                    </label>
                </div>
            </div>
            <address-form v-if="!billing.useDriverAddress"
                          :address="billing.address"
                          :country-codes="Geo.getCcAllowedCountryCodes()"
                          :errors="errors ? errors.address : {}"
                          name="billing"></address-form>
        </div>
    </div>
</template>

<script>
    import AddressForm from '../../Misc/AddressForm';
    import Geo from '../../../../Utils/Geo';

    export default {
        name: 'PaymentDetails',
        components: {
            AddressForm
        },
        props: ['searchParams', 'billing', 'errors'],
        computed: {
            minYear() {
                return moment().year();
            },
            maxYear() {
                return moment().add(14, 'year').year();
            },
            Geo() {
                return Geo;
            }
        },
        methods: {
            openCvvPopup() {
                window.open(window.env.baseUri + 'checkout/cvv-pop',
                    'cvv-pop',
                    'toolbar=0,location=0,directories=0,status=0,scrollbars=1,resizable=0,copyhistory=0,menuBar=0,width=365,height=605'
                );
            },
        }
    };
</script>

<style scoped>

</style>